export default __webpack_public_path__ + "static/media/frank.d8e1b770.svg";